// extracted by mini-css-extract-plugin
module.exports = {"figure":"Image_figure__3mO1Z","image":"Image_image__U2GuZ","figcaption":"Image_figcaption__4oUE9"};